export default [
  { key: "{{d.comum.dataAtual}}", description: "Data atual (curta)" },
  { key: "{{d.comum.dataAtualExtenso}}", description: "Data atual por extenso" },
  { key: "{{d.comum.horaAtual}}", description: "Hora atual" },
  { key: "{{d.locacao.numero}}", description: "Número da locação" },
  { key: "{{d.locacao.dataEfetivacao}}", description: "Data de efetivação" },
  { key: "{{d.locacao.dataCadastro}}", description: "Data de cadastro" },
  { key: "{{d.locacao.horaCadastro}}", description: "Hora do cadastro" },
  { key: "{{d.locacao.identificacao}}", description: "Identificação da locação" },
  { key: "{{d.locacao.tipoLocacao}}", description: "Tipo da locação" },
  { key: "{{d.locacao.obsLocacao}}", description: "Observações da locação" },
  { key: "{{d.locacao.obsOs}}", description: "Observações da OS" },
  { key: "{{d.locacao.total}}", description: "Total da locação" },
  { key: "{{d.locacao.totalExtenso}}", description: "Total por extenso" },
  { key: "{{d.locacao.totalCusto}}", description: "Total de custo" },
  { key: "{{d.locacao.totalCustoExtenso}}", description: "Total de custo por extenso" },
  { key: "{{d.locacao.totalReposicao}}", description: "Total de reposição" },
  { key: "{{d.locacao.totalReposicaoExtenso}}", description: "Total de reposição por extenso" },
  { key: "{{d.locacao.totalDesconto}}", description: "Total de desconto" },
  { key: "{{d.locacao.totalDescontoExtenso}}", description: "Total de desconto por extenso" },
  { key: "{{d.locacao.cliente.razaoSocialNome}}", description: "Razão social / Nome" },
  { key: "{{d.locacao.cliente.fantasiaApelido}}", description: "Nome fantasia / Apelido" },
  { key: "{{d.locacao.cliente.cnpjCpfTitulo}}", description: "Título CNPJ/CPF" },
  { key: "{{d.locacao.cliente.cnpjCpf}}", description: "CNPJ/CPF" },
  { key: "{{d.locacao.cliente.irTitulo}}", description: "Título IE" },
  { key: "{{d.locacao.cliente.ir}}", description: "Inscrição estadual" },
  { key: "{{d.locacao.cliente.im}}", description: "Inscrição municipal" },
  { key: "{{d.locacao.cliente.cep}}", description: "CEP" },
  { key: "{{d.locacao.cliente.rua}}", description: "Rua" },
  { key: "{{d.locacao.cliente.numero}}", description: "Número" },
  { key: "{{d.locacao.cliente.complemento}}", description: "Complemento" },
  { key: "{{d.locacao.cliente.bairro}}", description: "Bairro" },
  { key: "{{d.locacao.cliente.cidade}}", description: "Cidade" },
  { key: "{{d.locacao.cliente.estado}}", description: "Estado" },
  { key: "{{d.locacao.cliente.telefone}}", description: "Telefone" },
  { key: "{{d.locacao.cliente.site}}", description: "Site" },
  { key: "{{d.locacao.cliente.email}}", description: "E-mail" },
  { key: "{{d.locacao.colaborador.nome}}", description: "Nome do colaborador" },
  { key: "{{d.locacao.colaborador.apelido}}", description: "Apelido do colaborador" },
  { key: "{{d.locacao.colaborador.celular}}", description: "Celular do colaborador" },
  { key: "{{d.locacao.colaborador.email}}", description: "E-mail do colaborador" },
  { key: "{{d.locacao.contato.nome}}", description: "Nome do contato" },
  { key: "{{d.locacao.contato.celular}}", description: "Celular do contato" },
  { key: "{{d.locacao.contato.email}}", description: "E-mail do contato" },
  { key: "{{d.periodo.inicioFim}}", description: "Período de início e fim" },
  { key: "{{d.periodo.entregaRetirada}}", description: "Período de entrega e retirada" },
  { key: "{{d.pagamentoLocacao}}", description: "Forma de pagamento da locação" },
  { key: "{{d.pagamentoFaturar}}", description: "Forma de pagamento do faturamento" }
];
